<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fhDoPu/media/FC-9781398492066.jpg?1697494195245" alt="This image is the cover for the book Dosser's Dreams"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dosser's Dreams
      </h1>
      <p class="bookDescription body article font2">
        <p>We all dream when we sleep. Whether you can remember your dreams is neither here nor there as we all daydream. Both nocturnal dreams and daydreams are part of our mental health and how we see and interpret the world. Dosser’s Dreams are about the dreams of Dosser, a fictional character that emanates from his dreams.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alexander Rodger
      </h2>
      
      <p class="authorDescription body article">Born in Scotland but brought up in Ghana, Alexander did an MA Hons at the University of Edinburgh in Politics and Philosophy, followed by an MA in German and a doctorate at the University of West Berlin. Turning his back on the academic life, he produced 27 plays, five films and several documentaries. After the fall of the Berlin wall, he moved to Paris and works as an author and music producer.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f59577b2